import {createApp} from 'vue'
import Store from 'store'
import OrderHistoryTable from './OrderHistoryTable'

const component = createApp(OrderHistoryTable).use(Store)

const el = '.nlx-component--order-history-table'
const DOM = document.querySelector(el)

if(DOM){
    const orderHistoryData = JSON.parse(DOM.dataset.table)
    Store.dispatch('order/setOrderHistory', orderHistoryData)
    component.mount(el)
}

